import {
  ApplicationSubtype,
  AppPageContentWrapper,
  CircularTextLoader,
  PageContentBox,
  THUNK_STATUS,
} from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import { resetSeVerLetterRequest } from "../../../../store/redux/slice/Forms/seVerLetterForm";
import ServiceStepper from "../common/stepper/ServiceStepper";
import { fetchLoggedUserDetails } from "../../../../store/redux/slice/AppData/loggedUser";

const SeVerLetterNew = () => {
  const dispatch = useAppDispatch();

  const seVerLetterForm = useAppSelector((state) => {
    return state.Forms.SEVerLetterForm;
  });

  useEffect(() => {
    dispatch(resetSeVerLetterRequest());
    dispatch(fetchLoggedUserDetails());
  }, [dispatch]);

  return (
    <AppPageContentWrapper>
      <PageContentBox>
        <Box sx={{ width: "100%" }}>
          {seVerLetterForm.dataStateStatus === THUNK_STATUS.INITIAL ? (
            <ServiceStepper
              serviceSteps={seVerLetterForm.steps}
              applicationSubtype={ApplicationSubtype.SE_RECOGNITION}
            />
          ) : (
            <CircularTextLoader />
          )}
        </Box>
      </PageContentBox>
    </AppPageContentWrapper>
  );
};

export default SeVerLetterNew;
